import {
  getFormattedDate,
  dateFormatType,
  Tooltip,
} from "@SeemplicityDev/shared";
import { queueStatus, queueError } from "../../RemediationQueuesUtils";
import React, { useMemo } from "react";
import "./QueueStatus.scss";
import { ticketEndpointTypeEnum } from "@SeemplicityDev/ticket-master";

export interface QueueStatusProps {
  status: string;
  originalRow: any; // TODO: fe-guild add type
  queueType?: string; // TODO: fe-guild fix ticketEndpointTypeEnum implemetation - should be an enum and not an object
}

const QueueStatus: React.FC<QueueStatusProps> = ({
  status,
  originalRow,
  queueType,
}: QueueStatusProps) => {
  const statusTip = useMemo(() => {
    switch (originalRow?.status) {
      case queueStatus.SYNCED.value: {
        return "Queue is active";
      }
      case queueStatus.PAUSED.value: {
        const formattedDate = getFormattedDate(
          originalRow?.updated_time,
          dateFormatType.LONG
        );
        return `Queue disabled on ${formattedDate}\n by ${originalRow?.updated_by}`;
      }
      case queueStatus.ERROR.value: {
        if (!!originalRow?.status_details?.errors?.length) {
          if (originalRow?.status_details?.errors?.length === 1) {
            // TODO: fe-guild fix type error (the queueError is an object with string keys but still in js flie)
            return queueError[
              originalRow?.status_details?.errors[0]
                .error_type as keyof typeof queueError
            ]?.typeText;
          }
          return `Multiple errors\nReview details in the queue`;
        }
        return;
      }
      case queueStatus.RUNNING.value: {
        if (queueType && queueType === ticketEndpointTypeEnum.REPORT) {
          return "Sending Report";
        }
        return "Creating tickets";
      }
      case queueStatus.NEVER_SYNCED.value:
      default: {
        return "New queue not yet synced";
      }
    }
  }, [originalRow, queueType]);

  return (
    <Tooltip content={statusTip} className="rmq-list-tooltip">
      <div className={"status-col"} data-testid={"synced-row-data"}>
        <i
          className={`seem-icon ${queueStatus[originalRow?.status as keyof typeof queueStatus]?.icon}`}
        />
        {status}
      </div>
    </Tooltip>
  );
};

export default QueueStatus;
